import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  deactivateOrganization,
  DeactivateOrganizationBody,
  fetchDeactivationPreview,
  fetchOrganizationsV3,
  fetchOrganizationsV3Stats,
  OrganizationsV3QueryParams,
} from "../../services/OrganizationsV3Service";

// Error envelopes are shaped { "msg": "..." }; surface that message to the UI.
const toErrorMessage = (error: unknown): string => {
  const err = error as { response?: { data?: { msg?: string } }; message?: string };
  return err.response?.data?.msg || err.message || "An unexpected error occurred";
};

export const fetchOrganizationsV3Async = createAsyncThunk(
  "organizationsV3/fetchList",
  async (params: OrganizationsV3QueryParams, { rejectWithValue }) => {
    try {
      return await fetchOrganizationsV3(params);
    } catch (error: unknown) {
      return rejectWithValue(toErrorMessage(error));
    }
  }
);

export const fetchOrganizationsV3StatsAsync = createAsyncThunk(
  "organizationsV3/fetchStats",
  async (parentId: number | undefined, { rejectWithValue }) => {
    try {
      return await fetchOrganizationsV3Stats(parentId);
    } catch (error: unknown) {
      return rejectWithValue(toErrorMessage(error));
    }
  }
);

export const fetchDeactivationPreviewAsync = createAsyncThunk(
  "organizationsV3/fetchDeactivationPreview",
  async (orgId: number, { rejectWithValue }) => {
    try {
      return await fetchDeactivationPreview(orgId);
    } catch (error: unknown) {
      return rejectWithValue(toErrorMessage(error));
    }
  }
);

export const deactivateOrganizationAsync = createAsyncThunk(
  "organizationsV3/deactivate",
  async (
    { orgId, body }: { orgId: number; body: DeactivateOrganizationBody },
    { rejectWithValue }
  ) => {
    try {
      return await deactivateOrganization(orgId, body);
    } catch (error: unknown) {
      return rejectWithValue(toErrorMessage(error));
    }
  }
);
